import { createSelector } from '@reduxjs/toolkit';
import tableSelector from './table';

const summarySelector = createSelector(tableSelector, (table) => table.summary);

export default summarySelector;
